import { useEffect } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { Location } from "@/custom-types/Location";
import { useDispatch, useSelector } from "@/redux/hooks";
import { getLocationState } from "@/redux/selectors/location";
import { disableLocationChangeReload } from "@/redux/slices/header";

const useCustomLocationPickerUpdateBehavior = (
  initialCoordinates: Location["coordinates"],
) => {
  const dispatch = useDispatch();
  const { replace } = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const location = useSelector(getLocationState);

  const initialLat = initialCoordinates?.lat || initialCoordinates?.latitude;
  const initialLon = initialCoordinates?.lon || initialCoordinates?.longitude;

  useEffect(() => {
    dispatch(disableLocationChangeReload());
  }, []);

  useEffect(() => {
    const [_, routeRoot, _routeLocaleSlug, _routeSubLocaleSlug] =
      pathname?.split("/") || [];

    const { coordinates } = location;

    if (initialLat !== coordinates.lat || initialLon !== coordinates.lon) {
      const targetSearchParams = new URLSearchParams(searchParams?.toString());
      targetSearchParams.delete("top_lat");
      targetSearchParams.delete("bottom_lat");
      targetSearchParams.delete("left_lon");
      targetSearchParams.delete("right_lon");
      targetSearchParams.delete("page");
      targetSearchParams.delete("country");
      const targetQueryString =
        targetSearchParams.toString().length > 0
          ? `?${targetSearchParams.toString()}`
          : "";

      let destinationPath = `/${routeRoot}`;
      if (targetQueryString) {
        destinationPath += `/${targetQueryString}`;
      }
      replace(destinationPath);
    }
  }, [pathname, searchParams, location, initialLat, initialLon]);
};

export default useCustomLocationPickerUpdateBehavior;
